/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_Customs_ClassificationInputs */

const en_reference_dataset_customs_classification = /** @type {(inputs: Reference_Dataset_Customs_ClassificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customs classifications`)
};

/**
* | output |
* | --- |
* | "Customs classifications" |
*
* @param {Reference_Dataset_Customs_ClassificationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_customs_classification = /** @type {((inputs?: Reference_Dataset_Customs_ClassificationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_Customs_ClassificationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_customs_classification(inputs)
});